import { useLocation } from '@reach/router'
import Chip from 'components/Chip'
import { DemoScheduler } from 'components/DemoScheduler'
import useiCloudReady from '../../hooks/useiCloudReady'
import queryString from 'query-string'
import React, { useEffect, useState } from 'react'
import HubspotForm from 'react-hubspot-form'

export default function Contact(props) {
    const icloudready = useiCloudReady()
    const location = useLocation()
    const [activeTab, setActiveTab] = useState(props.activeTab || 'demo')
    const demoCalenderUrl = props.demoCalenderUrl || 'https://calendly.com/icloudready/request-discovery'
    const demoCalenderTitle = props.demoCalenderTitle || 'Book a demo'
    const qaCalenderTitle = props.qaCalenderTitle || 'Book 30-min chat'
    const qaCalenderUrl = props.qaCalenderUrl || "https://calendly.com/icloudready/icloudready-30-minute-quick-chat"
    const handleChipClick = (tab) => {
        setActiveTab(tab)
        icloudready?.capture(`contact: clicked ${tab} button`)
        if (typeof window !== 'undefined') {
            window.location.hash = `#${tab}`
        }
    }

    useEffect(() => {
        const tab = location.hash.replace('#', '')
        const demo = queryString.parse(location.search)?.demo
        if (tab === 'contact' || tab === 'demo' || tab === 'qa') {
            setActiveTab(tab)
        }
    }, [location])

    return (
        <>
            {!props.hideTabs && (
                <div className="flex justify-center space-x-2 mt-6">
                    <Chip active={activeTab === 'demo'} onClick={() => handleChipClick('demo')}>
                        Book a demo
                    </Chip>
                    {/* <Chip active={activeTab === 'contact'} onClick={() => handleChipClick('contact')}>
                        Contact us
                    </Chip> */}
                    <Chip active={activeTab === 'qa'} onClick={() => handleChipClick('qa')}>
                        Book 30-min chat
                    </Chip>
                </div>
            )}
            <div className="mt-8">
                {activeTab === 'contact' ? (
                    <div className="max-w-xl mx-auto mt-12">
                        <HubspotForm
                            portalId="39517643"
                            formId="82bf274d-76ea-4cc4-b1ef-50066538de0e"
                            onSubmit={() => setSubmitted(true)}
                        />
                    </div>
                ) : null}
                {/* {activeTab === 'demo' ? (
                    <div className="max-w-xl mx-auto mt-12">
                        <HubspotForm
                            portalId="39517643"
                            formId="11248317-d2ba-40aa-8390-265613804499"
                            onSubmit={() => setSubmitted(true)}
                        />
                    </div>
                ) : null} */}
                                {activeTab === 'demo' ? (
                    <DemoScheduler
                        type="demo"
                        iframeSrc= {demoCalenderUrl}
                    />
                ) : null}
                {activeTab === 'qa' ? (
                    <DemoScheduler
                        type="qa"
                        iframeSrc={qaCalenderUrl}
                    />
                ) : null}
            </div>
        </>
    )
}
